import { render, staticRenderFns } from "./powerBiStepProperties.vue?vue&type=template&id=105146e8&"
import script from "./powerBiStepProperties.vue?vue&type=script&lang=js&"
export * from "./powerBiStepProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports